import React from "react";
import { useTranslation } from "react-i18next";
import { GridRenderCellParams } from "@mui/x-data-grid";

import { BillingPaymentScheduleType } from "../../types/billings";

interface ITablePaymentScheduleCellProps {
  params: GridRenderCellParams<BillingPaymentScheduleType>;
}

export const TablePaymentScheduleCell: React.FC<ITablePaymentScheduleCellProps> = ({ params }) => {
  const { t } = useTranslation();

  return <p>{t(`billingPaymentScheduleType.${params.value}`)}</p>;
};
